import {
  generateDynamicCalendarColumns,
  getPortfolioStatisticsRows,
} from 'pages/Cases/PortfolioConstruction/Summary/PerformanceReport';

import { Grid } from '@mui/material';
import { SlideParagraph, SlideTitle } from 'features/slides';
import SummaryPerformanceTable from 'pages/Cases/components/SummaryPerformanceTable';
import { portfolioStatisticsChartFilter } from 'pages/Cases/PortfolioConstruction/Summary/PerformanceReport';
import React from 'react';

export type CalendarYearReturnsTableProps = {
  readonly filteredPerformance: any;
};

export function CalendarYearReturnsTable({
  filteredPerformance,
}: CalendarYearReturnsTableProps): React.ReactElement {
  const filteredData = portfolioStatisticsChartFilter({
    filteredPerformance,
    name: 'calendar_yr_returns',
  });

  const dynamicColumns = generateDynamicCalendarColumns(filteredData);

  return (
    <Grid
      container
      flexDirection="column"
      gap={0}
      sx={{
        width: '100%',
        padding: '10px',
      }}
    >
      <Grid
        container
        sx={{
          marginBottom: '6px',
        }}
      >
        <SlideTitle>Calendar Year Returns</SlideTitle>
      </Grid>

      <Grid sx={{ width: '100%', backgroundColor: '#fff' }}>
        <SummaryPerformanceTable
          rows={getPortfolioStatisticsRows(filteredData)}
          columns={dynamicColumns}
        />
      </Grid>
      <SlideParagraph
        style={{
          marginBottom: '10px',
          marginTop: '10px',
          fontSize: '13px',
        }}
      >
        Source: TIFIN Sage
      </SlideParagraph>
    </Grid>
  );
}
